export const title = "Laporan History Service Dutro";

export const tableWidth = "w-[53.5rem]";

export const paramSettings = [];

export const generateDefaultReportParams = () => {
  const defaultParam = {};

  for (let param of paramSettings) {
    defaultParam[param.name] = param.default;
  }

  return defaultParam;
};

export const groupSetting = {
  name: "Kendaraan",
  field: "data_kendaraan.nomor_polisi",
  data_field: "data_kendaraan",
};

export const columnSettings = [
  {
    name: "NO",
    field: "no",
    type: "number",
    width: "w-[3.5rem]",
    layout: "col-start-center",
  },
  {
    name: "SERVICE",
    field: "data_service",
    type: "string",
    width: "w-[15rem]",
    layout: "col-start-start",
  },
  {
    name: "SERVICE TERAKHIR",
    field: "tanggal_transaksi",
    type: "date",
    format: "dd/MM/yyyy",
    layout: "col-start-start",
    width: "w-[13.5rem]",
  },
  {
    name: "KM SERVICE",
    field: "speedo_akhir",
    type: "number",
    width: "w-[15rem]",
    layout: "col-start-start",
  },
  {
    name: "KETERANGAN",
    field: "keterangan",
    type: "string",
    width: "w-[15rem]",
    layout: "col-start-start",
  },
];
